import * as Yup from 'yup';
import {
  DOMAIN_REG_EX,
  EMAIL_REG_EX,
  LOWERCASE_REG_EX,
  NUMERIC_REG_EX,
  SPECIAL_CHARACTER_REG_EX,
  PHONE_REG_EX,
  UPPERCASE_REG_EX,
} from '../utils/regex';
import { INSTANCE_DEFAULT_CURRENCY_TYPE_ID } from '../utils/instanceConstant';

export const getAdminOrgUserCreateInitialValues = (admin) => {
  return {
    orgIndustrySectorTypeId:
      admin && admin.orgIndustrySectorTypeId
        ? admin.orgIndustrySectorTypeId
        : '',
    organisationName:
      admin && admin.organisationName ? admin.organisationName : '',
    orgPhone: admin && admin.orgPhone ? admin.orgPhone : '',
    orgDomain: admin && admin.orgDomain ? admin.orgDomain : '',
    orgEmail: admin && admin.orgEmail ? admin.orgEmail : '',
    userFirstName: admin && admin.userFirstName ? admin.userFirstName : '',
    userSurname: admin && admin.userSurname ? admin.userSurname : '',
    isTaksoAdminEmail:
      admin && admin.isTaksoAdminEmail ? admin.isTaksoAdminEmail : '',
    userEmail: admin && admin.userEmail ? admin.userEmail : '',
    password: admin && admin.password ? admin.password : '',
    confirmPassword:
      admin && admin.confirmPassword ? admin.confirmPassword : '',
    passwordIndv: admin && admin.passwordIndv ? admin.passwordIndv : '',
    confirmPasswordIndv:
      admin && admin.confirmPasswordIndv ? admin.confirmPasswordIndv : '',
    individualPaymentPreferenceId:
      admin && admin.individualPaymentPreferenceId
        ? admin.individualPaymentPreferenceId
        : '',
    individualSubscription:
      admin && admin.individualSubscription ? admin.individualSubscription : '',
    userFirstNameIndv:
      admin && admin.userFirstNameIndv ? admin.userFirstNameIndv : '',
    userPhoneIndv: admin && admin.userPhoneIndv ? admin.userPhoneIndv : '',
    userSurnameIndv:
      admin && admin.userSurnameIndv ? admin.userSurnameIndv : '',
    userEmailIndv: admin && admin.userEmailIndv ? admin.userEmailIndv : '',
    currencyTypeId:
      admin && admin.currencyTypeId
        ? admin.currencyTypeId
        : INSTANCE_DEFAULT_CURRENCY_TYPE_ID,
  };
};

//organisation
export const getAdminUserCreateValidationSchemaOrg = (
  t,
  isTaksoAdminEmail = false,
  isBetaLaunchAdmin = false
) => {
  let validationObject = {
    orgPhone: Yup.string()
      .required(t('formulary.validation.number_required'))
      .matches(PHONE_REG_EX, t('formulary.validation.phone_number_not_valid'))
      .min(10, t('formulary.validation.must_be_a_minimum_of_10_digits')),
    orgIndustrySectorTypeId: Yup.string().required(
      t('formulary.validation.industry_sector_type_id_required')
    ),
    organisationName: Yup.string().required(
      t('formulary.validation.organisation_name_required')
    ),
    orgDomain: Yup.string()
      .required(t('formulary.validation.web_domain_required'))
      .matches(
        DOMAIN_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      ),
    orgEmail: Yup.string()
      .required(t('formulary.validation.email_required'))
      .matches(
        EMAIL_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      ),
    userFirstName: Yup.string().required(
      t('formulary.validation.first_name_required')
    ),
    userSurname: Yup.string().required(
      t('formulary.validation.last_name_required')
    ),
    userEmail: Yup.string()
      .required(t('formulary.validation.email_required'))
      .matches(
        EMAIL_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      ),
  };

  if (isTaksoAdminEmail) {
    validationObject = {
      ...validationObject,
      password: Yup.string()
        .min(8, 'LENGTH_ERROR')
        .required('LENGTH_ERROR')
        .matches(LOWERCASE_REG_EX, 'LOWERCASE_ERROR')
        .matches(UPPERCASE_REG_EX, 'UPPERCASE_ERROR')
        .matches(NUMERIC_REG_EX, 'NUMERIC_ERROR')
        .matches(SPECIAL_CHARACTER_REG_EX, 'SPECIAL_CHARACTER_ERROR'),
      confirmPassword: Yup.string()
        .required(t('formulary.validation.confirm_password_required'))
        .oneOf(
          [Yup.ref('password'), null],
          t('formulary.validation.doesnt_match_the_new_password')
        ),
    };
  }

  if (isBetaLaunchAdmin) {
    validationObject = {
      ...validationObject,
      currencyTypeId: Yup.number().required(
        t('formulary.validation.currency_type_required')
      ),
    };
  }

  return Yup.object().shape(validationObject);
};

//individuals
export const getAdminUserCreateValidationSchemaIndv = (
  t,
  isTaksoAdminEmail = false,
  isBetaLaunchAdmin = false
) => {
  let validationObject = {
    individualPaymentPreferenceId: Yup.string().required(
      t('formulary.validation.payment_preference_required')
    ),
    individualSubscription: Yup.string().required(
      t('formulary.validation.subscription_required')
    ),
    userFirstNameIndv: Yup.string().required(
      t('formulary.validation.first_name_required')
    ),
    userSurnameIndv: Yup.string().required(
      t('formulary.validation.last_name_required')
    ),
    userEmailIndv: Yup.string()
      .required(t('formulary.validation.email_required'))
      .matches(
        EMAIL_REG_EX,
        t('formulary.validation.please_enter_the_valid_format')
      ),
    userPhoneIndv: Yup.string()
      .required(t('formulary.validation.number_required'))
      .matches(PHONE_REG_EX, t('formulary.validation.phone_number_not_valid'))
      .min(10, t('formulary.validation.must_be_a_minimum_of_10_digits')),
  };

  if (isTaksoAdminEmail) {
    validationObject = {
      ...validationObject,
      passwordIndv: Yup.string()
        .min(8, 'LENGTH_ERROR')
        .required('LENGTH_ERROR')
        .matches(LOWERCASE_REG_EX, 'LOWERCASE_ERROR')
        .matches(UPPERCASE_REG_EX, 'UPPERCASE_ERROR')
        .matches(NUMERIC_REG_EX, 'NUMERIC_ERROR')
        .matches(SPECIAL_CHARACTER_REG_EX, 'SPECIAL_CHARACTER_ERROR'),
      confirmPasswordIndv: Yup.string()
        .required(t('formulary.validation.confirm_password_required'))
        .oneOf(
          [Yup.ref('passwordIndv'), null],
          t('formulary.validation.doesnt_match_the_new_password')
        ),
    };
  }

  if (isBetaLaunchAdmin) {
    validationObject = {
      ...validationObject,
      currencyTypeId: Yup.number().required(
        t('formulary.validation.currency_type_required')
      ),
    };
  }

  return Yup.object().shape(validationObject);
};
